import {humanizeCapitalizeString} from '@veasel/core/tools';

const humanizeCapitalize = (value) => humanizeCapitalizeString(value);

export default humanizeCapitalize;
